import { DealStepEnum } from '../_enums/_index';

export class WizardStep {
    name: string;
    value: DealStepEnum;
    cssClass: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/wizard-step.model.ts